/* statusContainer.ts */

/* Interfaces */
import { Status } from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface StatusMapping {
  label: string;
  color: string;
}

export const getStatusMapping = (
  status: Status | string
): StatusMapping | undefined => {
  switch (status) {
    case Status.SAVED:
      return {
        color: "var(--ion-color-saved)",
        label: "saved",
      };
    case Status.EDITING:
      return {
        color: "var(--ion-color-editing)",
        label: "editing",
      };
    case Status.MODIFIED:
      return {
        color: "var(--ion-color-updated)",
        label: "modified",
      };
    case "experimental":
      return {
        color: "var(--ion-color-error)",
        label: "experimental",
      };
    default:
      return undefined;
  }
};
